import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Scissors, ArrowRightLeft, RefreshCw, ClipboardCheck, HeartPulse, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function ServicesSection() {
  const {
    t
  } = useLanguage();
  const services = [{
    icon: Scissors,
    titleEn: 'Sleeve Gastrectomy',
    titleEs: 'Manga gástrica',
    descEn: 'A procedure that removes a portion of the stomach to reduce its size, helping you feel full sooner.',
    descEs: 'Procedimiento que remueve una parte del estómago para reducir su tamaño y ayudar a sentir saciedad antes.'
  }, {
    icon: ArrowRightLeft,
    titleEn: 'Gastric Bypass',
    titleEs: 'Bypass gástrico',
    descEn: 'A surgery that changes how your stomach and small intestine handle the food you eat.',
    descEs: 'Cirugía que cambia la forma en que el estómago y el intestino delgado procesan los alimentos.'
  }, {
    icon: RefreshCw,
    titleEn: 'Revisional Bariatric Surgery',
    titleEs: 'Cirugía bariátrica de revisión',
    descEn: 'Corrective procedures for patients who have had previous weight loss surgery and need further treatment.',
    descEs: 'Procedimientos correctivos para pacientes que ya tuvieron cirugía bariátrica y necesitan tratamiento adicional.'
  }, {
    icon: ClipboardCheck,
    titleEn: 'Pre-Op Evaluation',
    titleEs: 'Evaluación preoperatoria',
    descEn: 'Comprehensive medical assessment to ensure you are a safe candidate for surgery.',
    descEs: 'Evaluación médica integral para asegurar que eres un candidato seguro para la cirugía.'
  }, {
    icon: HeartPulse,
    titleEn: 'Post-Op Follow-Up',
    titleEs: 'Seguimiento postoperatorio',
    descEn: 'Ongoing medical support and monitoring to help maintain your health after surgery.',
    descEs: 'Apoyo médico continuo y monitoreo para ayudar a mantener tu salud después de la cirugía.'
  }];
  return <section className="py-16 md:py-32 bg-white" id="services" data-id="element-202">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-203">
        <div className="mb-10 sm:mb-16 pl-5 sm:pl-6 border-l-4 border-[#0d9488]" data-id="element-204">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-[#0f172a] mb-3 sm:mb-4" data-id="element-205">
            {t('Our Services', 'Nuestros servicios')}
          </h2>
          <p className="text-base sm:text-lg text-slate-600 max-w-2xl" data-id="element-206">
            {t('Comprehensive weight loss solutions tailored to your unique health needs.', 'Soluciones integrales de pérdida de peso adaptadas a sus necesidades de salud únicas.')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-8" data-id="element-207">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-white rounded-xl shadow-sm hover:shadow-xl transition-all duration-300 border border-slate-100 overflow-hidden flex flex-col group" data-id="element-208">
              {/* Card Header Band */}
              <div className="bg-[#0f172a] h-24 relative flex items-center justify-center" data-id="element-209">
                <div className="absolute -bottom-8 bg-white p-3 rounded-full shadow-md border-4 border-white" data-id="element-210">
                  <service.icon className="w-8 h-8 text-[#0d9488]" data-id="element-211" />
                </div>
              </div>

              <div className="pt-12 pb-8 px-8 flex-1 flex flex-col" data-id="element-212">
                <h3 className="text-xl font-bold text-[#0f172a] mb-3 text-center" data-id="element-213">
                  {t(service.titleEn, service.titleEs)}
                </h3>

                <p className="text-slate-600 mb-6 leading-relaxed text-center flex-1 text-sm" data-id="element-214">
                  {t(service.descEn, service.descEs)}
                </p>

                <div className="text-center mt-auto" data-id="element-215">
                  <a href="#contact" className="inline-flex items-center text-[#0d9488] font-bold text-sm hover:text-[#0f766e] transition-colors group/link" data-id="element-216">
                    {t('Learn more', 'Ver más')}
                    <ArrowRight className="w-4 h-4 ml-1 transform group-hover/link:translate-x-1 transition-transform" data-id="element-217" />
                  </a>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}